// extracted by mini-css-extract-plugin
export default {"alarmLogs":"AlarmLogs_alarmLogs__8wtI5","wrapper":"AlarmLogs_wrapper__-qbAN","bodyWrapper":"AlarmLogs_bodyWrapper__1BsRg"};